// extracted by mini-css-extract-plugin
module.exports = {"privacy_policy":"PrivacyPolicy_privacy_policy__2K0Vi","privacy_policy_header":"PrivacyPolicy_privacy_policy_header__1Ji65"};